import { getMethod, postMethod, putMethod } from "../../api-service/api-service";
import {
    setTechniqueCategories,
    addTechniqueCategory,
    editTechniqueCategory,
    setLoading
} from "./techniqueCategorySlice";

// Fetch all technique categories
export const fetchAllTechniqueCategories = () => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await getMethod("/technique-category/");
        if (response.success === true) {
            dispatch(setTechniqueCategories(response.techniqueCategories));
        }
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        console.log("Error:", error);
    }
};

// Add new technique category
export const addTechniqueCategoryAction = (data) => async (dispatch) => {
    try {
        const response = await postMethod('/technique-category', data);
        if (response.success === true) {
            dispatch(addTechniqueCategory(response.techniqueCategory));
        }
        return response;
    } catch (error) {
        console.log("Error:", error);
    }
};

// Edit technique category
export const editTechniqueCategoryAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/technique-category/${id}`, data);
        if (response.success === true) {
            dispatch(editTechniqueCategory(response.techniqueCategory));
        }
        return response;
    } catch (error) {
        console.log("Error:", error);
    }
};